import { render, staticRenderFns } from "./BasicBar.vue?vue&type=template&id=8fab1dde&"
import script from "./BasicBar.vue?vue&type=script&lang=js&"
export * from "./BasicBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports